import React, { useState } from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import {
  OfferContainer,
  OfferContent,
  OfferBtnArea,
  OfferScreenArea,
  OfferBtnPlace,
  BaseballBtn,
  KidBtn,
  KaszkietBtn,
  SyntheticBtn,
  OtherBtn,
  PinBtn,
  Screen,
} from "./OfferElementsEN";
import Pin from "../../images/pins.jpg";

const OfferSectionEN = ({ id }) => {
  const download = (e) => {
    console.log(e);
    fetch(e, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "image.jpg");
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [imageClicked, setImageClicked] = useState({
    Baseball: false,
    Kid: false,
    Kaszkiet: false,
    Synthetic: false,
    Other: false,
    Pins: false,
  });

  const onClickHandler = (order) => {
    const resetImages = {
      Baseball: false,
      Kid: false,
      Kaszkiet: false,
      Synthetic: false,
      Others: false,
      Pins: false,
    };
    setImageClicked({
      ...resetImages,
      [order]: true,
    });
  };

  return (
    <OfferContainer id={id}>
      <OfferContent>
        <OfferBtnArea>
          <OfferBtnPlace
            onClick={() => onClickHandler("Baseball")}
            className="Baseball"
          >
            <BaseballBtn>"Baseball" Caps</BaseballBtn>
          </OfferBtnPlace>
          <OfferBtnPlace onClick={() => onClickHandler("Kid")} className="Kid">
            <KidBtn>"Children's" Caps</KidBtn>
          </OfferBtnPlace>
          <OfferBtnPlace
            onClick={() => onClickHandler("Kaszkiet")}
            className="Kaszkiet"
          >
            <KaszkietBtn>"Peaked" Caps</KaszkietBtn>
          </OfferBtnPlace>
          <OfferBtnPlace
            onClick={() => onClickHandler("Synthetic")}
            className="Synthetic"
          >
            <SyntheticBtn>Knit and Yarn Caps</SyntheticBtn>
          </OfferBtnPlace>
          <OfferBtnPlace
            onClick={() => onClickHandler("Others")}
            className="Others"
          >
            <OtherBtn>"Other" Caps</OtherBtn>
          </OfferBtnPlace>
          <OfferBtnPlace
            onClick={() => onClickHandler("Pins")}
            className="Pins"
          >
            <PinBtn>Adjusters</PinBtn>
          </OfferBtnPlace>
        </OfferBtnArea>
        <OfferScreenArea>
          <Screen>
            {imageClicked.Baseball && (
              <ImageList sx={{ width: "100%", height: 450 }} cols={3}>
                {itemDataBaseball.map((item) => (
                  <ImageListItem
                    href={item.img}
                    onClick={(e) => download(item.img)}
                    key={item.img}
                    style={{
                      maxwidth: 200,
                      maxheight: 150,
                    }}
                  >
                    <img
                      style={{ cursor: "pointer" }}
                      src={`${item.img}? w=200 & h=150 & fit=crop & auto=format`}
                      alt={item.title}
                      loading="lazy"
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            )}
            {imageClicked.Kid && (
              <ImageList sx={{ width: "100%", height: 450 }} cols={3}>
                {itemDataKid.map((item) => (
                  <ImageListItem
                    href={item.img}
                    onClick={(e) => download(item.img)}
                    key={item.img}
                    style={{
                      maxwidth: 200,
                      maxheight: 150,
                    }}
                  >
                    <img
                      style={{ cursor: "pointer" }}
                      src={`${item.img}?w=200&h=150&fit=crop&auto=format`}
                      srcSet={`${item.img}?w=200&h=150&fit=crop&auto=format&dpr=22x`}
                      alt={item.title}
                      loading="lazy"
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            )}
            {imageClicked.Kaszkiet && (
              <ImageList sx={{ width: "100%", height: 450 }} cols={3}>
                {itemDataKaszkiet.map((item) => (
                  <ImageListItem
                    href={item.img}
                    onClick={(e) => download(item.img)}
                    key={item.img}
                    style={{
                      maxwidth: 200,
                      maxheight: 150,
                    }}
                  >
                    <img
                      style={{ cursor: "pointer" }}
                      src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                      srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=22x`}
                      alt={item.title}
                      loading="lazy"
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            )}
            {imageClicked.Synthetic && (
              <ImageList sx={{ width: "100%", height: 450 }} cols={3}>
                {itemDataSynthetic.map((item) => (
                  <ImageListItem
                    href={item.img}
                    onClick={(e) => download(item.img)}
                    key={item.img}
                    style={{
                      maxwidth: 200,
                      maxheight: 150,
                    }}
                  >
                    <img
                      style={{ cursor: "pointer" }}
                      src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                      srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=22x`}
                      alt={item.title}
                      loading="lazy"
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            )}
            {imageClicked.Others && (
              <ImageList sx={{ width: "100%", height: 450 }} cols={3}>
                {itemDataOthers.map((item) => (
                  <ImageListItem
                    href={item.img}
                    onClick={(e) => download(item.img)}
                    key={item.img}
                    style={{
                      maxwidth: 200,
                      maxheight: 150,
                    }}
                  >
                    <img
                      style={{ cursor: "pointer" }}
                      src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                      srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=22x`}
                      alt={item.title}
                      loading="lazy"
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            )}
            {imageClicked.Pins && (
              <img
                style={{ width: "100%", height: "450px" }}
                src={Pin}
                alt="Pins"
              />
            )}
          </Screen>
        </OfferScreenArea>
      </OfferContent>
    </OfferContainer>
  );
};

export default OfferSectionEN;

const itemDataBaseball = [
  {
    img: require("../../photo/baseball/2-4,5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/2-4.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/2-5,5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/2-5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/2-5+.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/2-5m.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/2-6,5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/2-6.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/2-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/3-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/3-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/3-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/3-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/3-11.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-13.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-17.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-22.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-23.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-25.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-28.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-29.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-32.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-33.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-36.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-37.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/4-38.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/5-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/5-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/5-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/5-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/5-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/5-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/5-30.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/6-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/6-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/9-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/9-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/9-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/10-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/10-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/10-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/10-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/12-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/12-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/12-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/13-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/13-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/13-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/13-15.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/14-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/14-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/14-15.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/14-16.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/15-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/15-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/16-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/16-18.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/17-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/17-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/17-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/17-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/17-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/17-14.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/17-21.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/baseball/17-22.jpg"),
    title: " ",
  },
];

const itemDataKid = [
  {
    img: require("../../photo/kid/1-0.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/1-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/1-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/2-0,5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/3-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/3-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/5-26.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/5-29.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/5-31.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/5-33.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/6-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/6-12.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/6-13.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/13-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/14-12.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/15-14.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/16-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/16-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/16-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kid/16-05.jpg"),
    title: " ",
  },
];

const itemDataKaszkiet = [
  {
    img: require("../../photo/kaszkiet/2-1,5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/2-1.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/2-1+.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/2-2,5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/2-2.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/3-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/3-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/3-16.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/4-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/4-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/4-14.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/4-16.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/4-20.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/5-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/5-11.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/5-14.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/5-18.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/5-19.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/5-22.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/5-27.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/5-28.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/5-34.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/6-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/7-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/7-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/7-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/8-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/8-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/8-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/8-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/10-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/12-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/13-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/13-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/13-12.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/14-14.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/15-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/15-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/15-12.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/16-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/16-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/16-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/16-17.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/17-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/17-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/17-11.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/17-15.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/17-17.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/kaszkiet/17-18.jpg"),
    title: " ",
  },
];

const itemDataSynthetic = [
  {
    img: require("../../photo/synthetic/2-0+.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/3-18.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/3-19.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/4-11.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/5-12.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/5-17.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/9-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/9-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/13-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/13-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/13-13.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/14-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/14-11.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/15-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/15-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/15-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/15-13.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/synthetic/16-11.jpg"),
    title: " ",
  },
];
const itemDataOthers = [
  {
    img: require("../../photo/others/2-3,5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/2-3.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/2-7,5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/2-7.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/2-8,5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/2-8.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/2-9.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/2-11.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/3-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/3-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/3-14.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/3-15.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/3-17.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-12.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-15.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-18.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-19.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-21.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-24.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-27.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-30.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-31.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-34.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/4-35.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-13.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-15.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-16.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-21.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-23.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-24.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-25.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/5-32.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/6-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/6-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/6-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/6-5,5.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/6-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/6-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/6-11.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/7-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/7-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/7-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/7-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/7-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/7-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/9-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/9-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/10-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/10-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/10-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/11-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/11-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/11-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/11-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/13-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/13-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/13-11.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/13-14.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/13-16.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/13-17.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/13-18.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/14-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/14-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/14-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/14-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/14-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/14-13.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/15-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/15-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/15-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/15-11.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/16-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/16-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/16-12.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/16-13.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/16-14.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/17-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/17-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/17-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/17-20.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/17-23.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-01.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-02.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-03.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-04.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-05.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-06.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-07.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-08.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-09.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-10.jpg"),
    title: " ",
  },
  {
    img: require("../../photo/others/18-12.jpg"),
    title: " ",
  },
];
